import BaseAPI from '../base'

function connect(cafe_id) {
    return BaseAPI.post(`/stripe/connect/${cafe_id}`);
}

function getOnboardingLink(cafe_id) {
    return BaseAPI.get(`/stripe/onboarding/${cafe_id}`);
}

function createWebhook(merchant_id) {
    return BaseAPI.post(`/stripe/create_webhook/${merchant_id}`);
}

export default {
    connect,
    getOnboardingLink,
    createWebhook
}